// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.stage.monatest.icu/auto-open-api-spec.yaml 1.8.4
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2025-04-03T11:23:33.079026+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';


/**
 * Serializer for ExternalApplication Model Structure.
 * @see #/components/schemas/ExternalApplication - reference to schema in open-api-spec.yaml
 * @since 2025-04-03T11:23:33.079026+03:00[Europe/Kiev]
 * @version 1.8.4
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface ExternalApplication { 
    readonly id: number;
    /**
     * Name of the external application
     * 
     */
    name: string;
    /**
     * Whether the application is visible
     * 
     */
    is_visible?: boolean;
    /**
     * Icon of the external application. Max size 5MB. Formats: jpg, jpeg, png, webp, ico
     * @dataFormat uri
     */
    icon?: string | null;
    /**
     * The field used to keep ordering added in admin page.
     * 
     */
    ordering_index?: number;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
* Namespace that holds Frontend models/classes for ExternalApplication
*/
export namespace ExternalApplication {

    /**
    * ExternalApplication Frontend Model with camelCase properties
    * @since 2025-04-03T11:23:33.079026+03:00[Europe/Kiev]
    * @version 1.8.4
    *
    * NOTE: This class is auto generated by OpenAPI Generator
    * Do not edit the class manually.
    */
    export class Model {
        readonly id: number;
        /**
        * Name of the external application
        * @type string (`dataFormat` is missing)
        */
        name: string;
        /**
        * Whether the application is visible
        * @type boolean (`dataFormat` is missing)
        */
        isVisible?: boolean;
        /**
        * Icon of the external application. Max size 5MB. Formats: jpg, jpeg, png, webp, ico
        * @dataFormat uri
        */
        icon?: string | null;
        /**
        * The field used to keep ordering added in admin page.
        * @type number (`dataFormat` is missing)
        */
        orderingIndex?: number;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
    * ExternalApplication DTO
    * Transforms ExternalApplication model from/to API object
    * @since 2025-04-03T11:23:33.079026+03:00[Europe/Kiev]
    * @version 1.8.4
    *
    * NOTE: This class is auto generated by OpenAPI Generator
    * Do not edit the class manually.
    */
    export class DTO {
        /** Transforms to Frontend ExternalApplication model */
        static toModel(obj: ExternalApplication): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend ExternalApplication model */
        static toApi(obj: Model): ExternalApplication {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as ExternalApplication;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}


